import {axios as http} from "@/plugins/http"

export default class Api {
    static uploadImage(q) {
        return http.post("/api/v1/shop/shop/upload-image", q)
    }
}
